import { Card, Form, Row, Col, Modal, Select, Button, Divider, Popconfirm, message } from 'antd';
import { useState } from 'react';
import { notifyMessages, requiredMessages } from '../../utils/constants';

const LavorazioneModal = ({ showLavorazioneModal, documentData, anomalies, handelModalClose, loadingRegisterDocument, registerDocument, onDocumentSospeso, loadingSospesoDocument, setNonCompetenza }) => {


    const [registerDocumentAnomaly, setRegisterDocumentAnomaly] = useState(null);
    const [sospesoDocumentAnomaly, setSospesoDocumentAnomaly] = useState(null);    

    const onRegisterAnomalySelect = (option) => {
        setRegisterDocumentAnomaly(option);
    }

    const onSospesoAnomalySelect = (option) => {
        setSospesoDocumentAnomaly(option);
    }


    const onRegisterDocument = () => {
        registerDocument(registerDocumentAnomaly)
    }

    const setDocumentSospeso = () => {
        onDocumentSospeso(sospesoDocumentAnomaly)
    }

    const onModalClose = () => {
        handelModalClose();
    }

    return (
        <Modal
            width={800}
            title="Lavorazione"
            open={showLavorazioneModal}
            destroyOnClose={true}
            onCancel={onModalClose}
            footer={[
                <Button key="close" onClick={handelModalClose}>Chiudi</Button>
            ]}
        >
            <Card>
                <Form layout="vertical">
                    <Row gutter={{ lg: 24 }} className="row-margin" style={{ alignItems: 'center' }}>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 16 }} lg={{ span: 16 }}>
                            <Form.Item
                                label="Anomalie"
                                hasFeedback
                            >
                                <Select
                                    showSearch
                                    placeholder="Seleziona"
                                    optionFilterProp="label"
                                    options={anomalies}
                                    onChange={(option) => onRegisterAnomalySelect(option)}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} style={{ justifyContent: "flex-end", display: "flex" }} >
                            <Button onClick={() => onRegisterDocument()} loading={loadingRegisterDocument} type="primary">Documento registrato</Button>
                        </Col>
                    </Row>
                </Form>

                <Divider />

                <Form layout="vertical" id='sospesoAnomali'>
                    <Row gutter={{ lg: 24 }} className="row-margin" style={{ alignItems: 'center' }}>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 16 }} lg={{ span: 16 }}>
                            <Form.Item
                                label="Anomalie"
                                name="sospesoAnomaly"
                                hasFeedback
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Seleziona"
                                    optionFilterProp="label"
                                    options={anomalies}
                                    onChange={(option) => onSospesoAnomalySelect(option)}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} style={{ justifyContent: "flex-end", display: "flex" }} >
                            <Button disabled={!sospesoDocumentAnomaly} onClick={() => setDocumentSospeso()}  loading={loadingSospesoDocument} type="primary">Documento in Sospeso</Button>
                        </Col>
                        <Divider />
                          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} style={{display: 'flex', justifyContent:"flex-end"}}>
                                                       <Popconfirm
                                title="Conferma?"
                                onConfirm={setNonCompetenza}
                                okText="Si"
                                cancelText="No"
                            >
                                <Button loading={loadingSospesoDocument} type="primary">Non di competenza</Button>
                            </Popconfirm>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </Modal>
    )
}

export default LavorazioneModal;
